import { useMemo } from 'react';
import { Member } from '../types/teams';

interface UseTeamMemberFiltersProps {
  roster: Member[];
  selectedMembers: Member[];
  searchTermInTeam: string;
  searchTermAvailable: string;
}

export const useTeamMemberFilters = ({
  roster,
  selectedMembers,
  searchTermInTeam,
  searchTermAvailable,
}: UseTeamMemberFiltersProps) => {
  const membersInTeam = useMemo(() => {
    return selectedMembers.filter(
      (member) =>
        member.user_name
          ?.toLowerCase()
          .includes(searchTermInTeam.toLowerCase()) ||
        member.email_address
          ?.toLowerCase()
          .includes(searchTermInTeam.toLowerCase()) ||
        member.role_string
          ?.toLowerCase()
          .includes(searchTermInTeam.toLowerCase())
    );
  }, [selectedMembers, searchTermInTeam]);

  const availableMembers = useMemo(() => {
    return roster
      .filter(
        (member) =>
          !selectedMembers.some((m) => m.user_guid === member.user_guid)
      )
      .filter(
        (member) =>
          member.user_name
            ?.toLowerCase()
            .includes(searchTermAvailable.toLowerCase()) ||
          member.email_address
            ?.toLowerCase()
            .includes(searchTermAvailable.toLowerCase()) ||
          member.role_string
            ?.toLowerCase()
            .includes(searchTermAvailable.toLowerCase())
      );
  }, [roster, selectedMembers, searchTermAvailable]);

  return {
    membersInTeam,
    availableMembers,
  };
};
